import { hasAttr } from './hasAttr';
import { removeAttrs } from './removeAttrs';

export function showElement(el) {
  if (hasAttr(el, 'hidden')) {
    removeAttrs(el, 'hidden');
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/showElement.js
// module id = 56
// module chunks = 0